module.exports = __webpack_public_path__ + "img/m-bg.bd4c197c.png";